























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class InboundCard extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  title!: string;

  @Prop({
    required: false,
    type: Boolean,
    default: true,
  })
  withoutEdit!: boolean;

  edit = false;

  @Watch('edit', { deep: true, })
  onEditChange(edit: boolean): void {
    this.$emit('edit', edit);
  }
}
